import { docReady } from "../utilities";
import Favourites from '../libraries/Favourites';
import Braze from '../libraries/Braze';
import '../styles/templates/search.scss';

docReady(function() {
    Favourites.init();
    Favourites.initButtons();

    const searchEl = document.querySelector(".search-results");
    if (searchEl && searchEl.dataset.searchPerformed === "true") {
        Braze.logSearchPerformed({
            search_term: searchEl.dataset.searchTerm || "",
            results_count: parseInt(searchEl.dataset.searchResultsCount || "0", 10),
        });
    }
});
